import { useState } from "react";
import useCreate from '../useCreate';
import toast from 'react-hot-toast';

const useDeleteBanner = () => {
  const [bannerId, setBannerId] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const { setDataToServer } = useCreate({
    url: 'banner/delete',
    refreshUrl: 'banner/list',
    onSuccess: () => {
      toast.success("Banner Deleted Successfully", {
        position: "top-right",
        duration: 3000
      });
      setDeleteModalOpen(false);
    }
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return {
    bannerId,
    setBannerId,
    isDeleteModalOpen,
    setDeleteModalOpen,
    handleSubmit,
  };
};

export default useDeleteBanner;
